import { FREE_PLAN_COUNTRY_CODES } from './free-plan-countries';

// Re-exported, not redeclared: the edge bundle deep-imports the leaf module.
export { FREE_PLAN_COUNTRY_CODES } from './free-plan-countries';

export const MAX_FREE_UPLOADS = 3;

const WEEK_MS = 7 * 24 * 60 * 60 * 1000;

export function isFreePlanCountryCode(countryCode: string | null | undefined) {
  return FREE_PLAN_COUNTRY_CODES.includes(
    countryCode?.toUpperCase() as (typeof FREE_PLAN_COUNTRY_CODES)[number],
  );
}

export function freeUploadWeekStartMs(nowMs: number) {
  const now = new Date(nowMs);
  const daysSinceMonday = (now.getUTCDay() + 6) % 7;
  const mondayAtEightUtc = Date.UTC(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate() - daysSinceMonday,
    8,
  );
  return nowMs < mondayAtEightUtc
    ? mondayAtEightUtc - WEEK_MS
    : mondayAtEightUtc;
}

export function nextFreeUploadResetMs(nowMs: number) {
  return freeUploadWeekStartMs(nowMs) + WEEK_MS;
}
